import { render, staticRenderFns } from "./ClosedProp2.vue?vue&type=template&id=2b71257d&"
import script from "./ClosedProp2.vue?vue&type=script&lang=js&"
export * from "./ClosedProp2.vue?vue&type=script&lang=js&"
import style0 from "./ClosedProp2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports